import { makeAutoObservable, runInAction } from "mobx";

export default class categoryStore {
  category = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.category = [];
    runInAction(() => {
      this.category = data;
    });
  };

  deleteCategory = (id) => {
    let newState = this.category.filter((category) => category.id !== id);
    this.category = [];
    this.category = newState;
  };
}